<template>
  <div
    v-if="isMobile"
    class="sticky-bar d-flex justify-content-between align-items-center"
  >
    <!-- Quote Logic -->
    <template v-if="showQuoteOrCartBlock">
      <div class="flex-grow-1 text-start">
        <p class="heading mb-1">{{ t('reservations.total') }}</p>
        <p class="heading fw-bold">
          <!-- Using PriceComponent -->
          <Price :price="booking.sellingPrice" />
        </p>
      </div>

      <ReserveActionsButton
        v-if="showReserveButton"
        :booking="props.booking"
        :default-label="t('reservations.reserve')"
        button-class="w-40"
      />
      <ReserveActionsButton
        v-else-if="showPayBalanceButton"
        :booking="props.booking"
        :default-label="payActionLabel"
        button-class="w-40"
      />
    </template>

    <!-- Reservation Logic -->
    <template v-else>
      <PaymentButton :userId="userId" :booking="props.booking" />
    </template>
  </div>
</template>

<script setup lang="ts">
  import { defineProps, computed, ComputedRef } from 'vue'
  import { useI18n } from 'vue-i18n'
  import PaymentButton from '@/components/common/PaymentButton.vue'
  import Price from '@/components/common/Price.vue' // Import PriceComponent
  import { useStore } from '@/store'
  import { BookingStatus } from '@/config'
  import { BookingSummary } from '@/services/BookingService.interface'

  // Composables
  import useScreenSize from '@/composables/useScreenSize'
  import ReserveActionsButton from '@/components/common/ReserveActionsButton.vue'
  import { useBookingFunnelActions } from '@/composables/useBookingFunnelActions'
  import { useBookingFunnelNavigation } from '@/composables/useBookingFunnelNavigation'

  const store = useStore()

  const props = defineProps({
    booking: {
      type: Object as () => BookingSummary,
      required: true,
    },
  })

  const userId: ComputedRef<string | null> = computed(
    () => store.state.auth?.user?.iresa_id || null
  )

  const { t } = useI18n()

  const showQuoteOrCartBlock = computed(() =>
    [BookingStatus.Quote, BookingStatus.CartInProgress].includes(
      props.booking.status
    )
  )

  const { showReserveButton, showPayBalanceButton } = useBookingFunnelActions(
    () => props.booking
  )
  const { payActionLabel } = useBookingFunnelNavigation(() => props.booking)

  // Methods
  const { isMobile } = useScreenSize()
</script>

<style scoped>
  .sticky-bar {
    position: sticky;
    bottom: 0;
    background-color: white;
    padding: 1rem;
    padding-bottom: 0rem;
    z-index: 1000;
    border-top: 1px solid var(--gray-200);
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow for clarity */
  }
</style>
